import { Outlet } from "react-router-dom";
import Sidebar from "../components/Common/Sidebar.jsx";
import Header from "../components/Common/Header.jsx";

const MainLayout = () => {
  return (
    <div style={{ display: "flex" }}>
      <Sidebar />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <Header />
        <div style={{ flex: 1, padding: "20px"}}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
